import CategoryLogo from './CategoryLogo';

export default CategoryLogo;
